// polyfills for older browsers.
import '@webcomponents/webcomponentsjs'
// application
import connect from './connect'
import SupportWidget from './components/SupportWidget.svelte'
import SupportPage from './components/SupportPage.svelte'

import * as Sentry from '@sentry/browser'

// Sentry
Sentry.init({
  dsn: 'process.env.SENTRY_DSN',
  environment: 'process.env.SENTRY_ENVIRONMENT',
  release: 'process.env.SENTRY_RELEASE',
})

// special function to map web components to web apps in a way global css and lightdom will work.
// borrowed from: https://github.com/cedeber/frontafino/tree/master/boilerplates/rollup-svelte
// see: https://github.com/sveltejs/svelte/issues/1748#issuecomment-602047540
connect('hdc-support-widget', SupportWidget, ['memberid', 'accountid', 'email'])
connect('hdc-support-page', SupportPage)

document.documentElement.setAttribute('data-release', 'process.env.BUILD_VERSION')

export default SupportPage
